import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import MultiSelect from "components/Common/UI/MultiSelect";
import { selectAccountProfileAttributeByName } from "reducers/account/profileAttributes";

export const AttributeMultiSelect = ({
  onChange,
  profileAttributes,
  property
}) => {
  const options = profileAttributes
    ? profileAttributes.values.map(attr => ({ value: attr, label: attr }))
    : [];
  return (
    <MultiSelect
      className="testid-browser-lang-input"
      name="values"
      options={options}
      allowCustomValues
      onChange={onChange}
      placeholder={property}
    />
  );
};

AttributeMultiSelect.propTypes = {
  property: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  profileAttributes: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string)
  })
};

const mapStateToProps = (state, { property }) => ({
  profileAttributes: selectAccountProfileAttributeByName(state, property)
});

export default connect(mapStateToProps)(AttributeMultiSelect);
